import { formatCOP, formatNumber } from "@/utils/format";

interface AsesorStatsProps {
  units: number;
  inventoryValue: number;
  salesCount: number;
  salesTotal: number;
}

const STAT_META = [
  { icon: "ri-archive-2-line", label: "Unidades en consignación", bubble: "bg-primary-500/25 text-primary-100" },
  { icon: "ri-money-dollar-circle-line", label: "Valor de tu inventario", bubble: "bg-accent-500/20 text-accent-200" },
  { icon: "ri-shopping-bag-3-line", label: "Ventas del período", bubble: "bg-secondary-500/25 text-secondary-200" },
  { icon: "ri-hand-coin-line", label: "Ganancia acumulada", bubble: "bg-accent-500/15 text-accent-100" },
];

// Resumen del asesor: su consignación y su desempeño comercial.
const AsesorStats = ({ units, inventoryValue, salesCount, salesTotal }: AsesorStatsProps) => {
  const values = [
    formatNumber(units),
    formatCOP(inventoryValue),
    formatNumber(salesCount),
    formatCOP(salesTotal * 0.25),
  ];

  return (
    <div className="grid grid-cols-2 xl:grid-cols-4 gap-3 md:gap-4">
      {STAT_META.map((meta, i) => (
        <div key={meta.label} className="glass-panel rounded-lg p-4 animate-fade-up">
          <span className={`w-9 h-9 rounded-lg flex items-center justify-center ${meta.bubble}`}>
            <i className={`${meta.icon} text-lg`} />
          </span>
          <p className="text-[11px] text-foreground-500 mt-3">{meta.label}</p>
          <p className="text-lg md:text-xl font-heading font-extrabold text-foreground-950 mt-0.5 break-words">
            {values[i]}
          </p>
        </div>
      ))}
    </div>
  );
};

export default AsesorStats;